/*
 *
 * PaymentMethods constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/PaymentMethods';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_PAYMENT_METHODS = `${BASE_ACTION_CONSTANT}/GET_PAYMENT_METHODS`;

export const HANDLE_PAYMENT_METHODS_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_PAYMENT_METHODS_RESPONSE`;

export const GET_OTHER_AVAILABLE_MODES = `${BASE_ACTION_CONSTANT}/GET_OTHER_AVAILABLE_MODES`;

export const HANDLE_OTHER_AVAILABLE_MODES_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_OTHER_AVAILABLE_MODES_RESPONSE`;

export const GET_PAYPAL_CONFIG = `${BASE_ACTION_CONSTANT}/GET_PAYPAL_CONFIG`;

export const HANDLE_PAYPAL_CONFIG_RESPONSE = `${BASE_ACTION_CONSTANT}/HANDLE_PAYPAL_CONFIG_RESPONSE`;

export const RESET_PAYMENT_METHOD_CARD_LOADER = `${BASE_ACTION_CONSTANT}/RESET_PAYMENT_METHOD_CARD_LOADER`;

export const INITIATE_PAYPAL = `${BASE_ACTION_CONSTANT}/INITIATE_PAYPAL`;

export const SAVE_PAYPAL_DATA = `${BASE_ACTION_CONSTANT}/SAVE_PAYPAL_DATA`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const PAYMENT_METHODS = {
  DEBIT_CARD: 'Debit Cards',
  CREDIT_CARD: 'Credit Cards',
  NET_BANKING: 'Net Banking',
  UPI: 'UPI',
  Wallet: 'Wallets',
  CREDIT_CARD_EMI: 'EMI on Card',
  CARDLESS_EMI: 'Cardless EMI',
  PAY_LATER: 'Pay Later',
  PREPAID_CARD: 'Prepaid Card',
  CORPORATE_CREDIT_CARD: 'Corporate Credit Card',
};

export const ZEST_MONEY_CODE = 6003;

export const INSTA_CRED_CODE = 6002;

export const ENABLED_PAYMENT_METHODS = [
  'DEBIT_CARD',
  'CREDIT_CARD',
  'PREPAID_CARD',
  'CORPORATE_CREDIT_CARD',
  'NET_BANKING',
  'UPI',
  'Wallet',
  'CARDLESS_EMI',
  'CREDIT_CARD_EMI',
  'PAY_LATER',
];

export const SAVE_PAYPAL_DATA_URL = {
  url: '/pg/paypal/onboardreturn',
  method: 'POST',
};

export const GET_OTHER_AVAILABLE_MODES_URL = {
  url: '/pg/paymentmode/all-modes',
  method: 'GET',
};

export const GET_ALL_MODES_OLD_URL = {
  url: '/pg/paymentmodes',
  method: 'GET',
};

export const NET_BANKING_PAYMENT_METHODS = [
  'axis',
  'hdfc',
  'icici',
  'indusind',
  'sbi',
  'yes',
];

export const CORPORATE_CREDIT_CARD_PAYMENT_METHODS = [
  'hdfc',
  'icici',
  'indusind',
  'sbi',
  'yes',
];

export const EMI_ON_CARD_PAYMENT_METHODS = [
  'hdfc',
  'icici',
  'sbi',
  'axis',
  'indusind',
];

export const INITIATE_PAYPAL_URL = {
  url: '/pg/paypal/initiate',
  method: 'POST',
};

export const GET_PAYPAL_CONFIG_URL = {
  url: '/pg/paypal/configs',
  method: 'GET',
};

export const GET_PAYPAL_CURRENCIES_URL = {
  url: '/pg/paypal/currencies',
  method: 'GET',
};

export const GET_ACTIVE_PAYPAL_CURRENCIES_URL = {
  url: '/pg/paypal/currencies/active',
  method: 'GET',
};

export const GET_DEFAULT_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/default',
  method: 'GET',
};

export const UPDATE_DEFAULT_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/make-default',
  method: 'PATCH',
};

export const DEACTIVATE_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/deactivate',
  method: 'PATCH',
};

export const ACTIVATE_PAYPAL_CURRENCY_URL = {
  url: '/pg/paypal/currencies/$currency_code$/activate',
  method: 'PATCH',
};

export const RESET_PAYPAL_CONFIG_URL = {
  url: '/pg/paypal/reset',
  method: 'PATCH',
};

export const ENABLE_PAYMENT_METHOD_URL = {
  url: '/pg/paymentmode/enable',
  method: 'POST',
};

export const GET_PAYMENT_METHOD_BY_STATUS_URL = {
  url: '/pg/paymentmode/status',
  method: 'GET',
};

export const GET_DOCS_PER_PAYMENT_METHOD_URL = {
  url: '/pg/paymentmode/requirements',
  method: 'GET',
};

export const RESET_PAYPAL_CONFIG = `${BASE_ACTION_CONSTANT}/RESET_PAYPAL_CONFIG`;

export const ACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/ACTIVATE_PAYPAL_CURRENCY`;

export const DEACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/DEACTIVATE_PAYPAL_CURRENCY`;

export const UPDATE_DEFAULT_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/UPDATE_DEFAULT_PAYPAL_CURRENCY`;

export const HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_UPDATE_DEFAULT_PAYPAL_CURRENCY`;

export const HANDLE_DEACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_DEACTIVATE_PAYPAL_CURRENCY`;

export const HANDLE_ACTIVATE_PAYPAL_CURRENCY = `${BASE_ACTION_CONSTANT}/HANDLE_ACTIVATE_PAYPAL_CURRENCY`;

export const ENABLE_PAYMENT_METHOD = `${BASE_ACTION_CONSTANT}/ENABLE_PAYMENT_METHOD`;

export const GET_DOCS_PER_PAYMENT_METHOD = `${BASE_ACTION_CONSTANT}/GET_DOCS_PER_PAYMENT_METHOD`;

export const PAYPAL = 'PAYPAL';

export const PAYTM = 'PAYTM';

export const START = 'START';

export const FIRST = 'FIRST';

export const SECOND = 'SECOND';

export const COMPLETED = 'COMPLETED';

export const PAYTM_MODAL = 'PAYTM_MODAL';

export const PAYTM_REPORT_GENERATED = 'PAYTM_REPORT_GENERATED';

export const CONNECT_PAYTM_ACCOUNT_SUCCESS = 'CONNECT_PAYTM_ACCOUNT_SUCCESS';

export const RESET_PAYPAL_MODAL = 'RESET_PAYPAL_MODAL';

export const RESET_PAYTM_MODAL = 'RESET_PAYTM_MODAL';

export const GET_PAYTM_DATA = `${BASE_ACTION_CONSTANT}/GET_PAYTM_DATA`;

export const SAVE_PAYTM_DATA = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_DATA`;

export const SAVE_UPLOAD_DOCUMENTS_FORM = `${BASE_ACTION_CONSTANT}/SAVE_UPLOAD_DOCUMENTS_FORM`;

export const GET_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/GET_PAYTM_TEST_CONFIG`;

export const SAVE_PAYTM_PROD_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_PROD_CONFIG`;

export const SAVE_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_PAYTM_TEST_CONFIG`;

export const ADD_PAYTM_PROD_CONFIG = `${BASE_ACTION_CONSTANT}/ADD_PAYTM_PROD_CONFIG`;

export const ADD_PAYTM_TEST_CONFIG = `${BASE_ACTION_CONSTANT}/ADD_PAYTM_TEST_CONFIG`;

export const GET_PAYTM_CHECKSUMHASH = `${BASE_ACTION_CONSTANT}/GET_PAYTM_CHECKSUMHASH`;

export const RESET_PAYTM_WALLET = `${BASE_ACTION_CONSTANT}/RESET_PAYTM_WALLET`;

export const DOWNLOAD_DOCUMENT = `${BASE_ACTION_CONSTANT}/DOWNLOAD_DOCUMENT`;

export const GET_PAYTM_PROD_CONFIG_URL = {
  url: '/pg/paytm/config/prod',
  method: 'GET',
};

export const ADD_PAYTM_PROD_CONFIG_URL = {
  url: '/pg/paytm/config/prod',
  method: 'PATCH',
};

export const GET_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'GET',
};

export const ADD_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'POST',
};

export const UPDATE_PAYTM_TEST_CONFIG_URL = {
  url: '/pg/paytm/config',
  method: 'PATCH',
};

export const GET_PAYTM_CHECKSUMHASH_URL = {
  url: '/pg/paytm/config/checksum',
  method: 'POST',
};

export const RESET_PAYTM_WALLET_URL = {
  url: '/pg/paytm/config/deactivate',
  method: 'PATCH',
};

export const PAYPAL_CONFIG = [
  {
    key: 'mid',
    displayText: 'Paypal MID',
    isEditable: false,
    showInfoIcon: false,
  },
  {
    key: 'conFee',
    displayText: 'Convenience Fee',
    isAmount: true,
    isEditable: false,
    showInfoIcon: false,
  },
  {
    key: 'flatFee',
    displayText: 'Convenience Fee (Flat)',
    isAmount: true,
    isEditable: false,
    showInfoIcon: false,
  },
  {
    key: 'defaultPaypalCurrency',
    displayText: 'Default Currency',
    isEditable: true,
    showInfoIcon: false,
  },
  {
    key: 'activePaypalCurrencies',
    displayText: 'Active Currencies',
    isEditable: true,
    showInfoIcon: false,
  },
];

export const PHONEPE_CODE = 4009;

export const PAYTM_CODE = 4007;

export const DINERS_CLUB = 1008;

export const AMEX = 1003;

export const WALLET = 'Wallet';

export const ENABLE_PAYMENT_METHODS_CODES = {
  [AMEX]: AMEX,
  [DINERS_CLUB]: DINERS_CLUB,
  [PHONEPE_CODE]: PHONEPE_CODE,
};

export const PAYTM_DASHBOARD_LINK = 'https://dashboard.paytm.com/next/apikeys';

export const GMAIL_LINK = 'https://mail.google.com/';

export const ERROR_CONFIG = 'ERROR_CONFIG';

export const STANDARD_PRICING_LINK =
  'https://www.cashfree.com/payment-gateway-charges';

export const ACTIVATE_PAYMENT_METHODS_LINK =
  'https://www.cashfree.com/docs/payments/manage/payment-methods#activating-payment-methods-from-the-dashboard';

export const IN_REVIEW = 'IN_REVIEW';

export const REJECTED = 'REJECTED';

export const PAYMENT_METHODS_STATUS = {
  IN_REVIEW,
  REJECTED,
};

export const DOCUMENT_STATUS_NOT_UPLOADED = 'NOT_UPLOADED';

export const DOCUMENT_STATUS_APPROVED = 'APPROVED';

export const CARDLESS_EMI = 'CARDLESS_EMI';

export const MAX_FILE_SIZE = 2;

export const PAYMENT_METHODS_HEADING = [
  {
    key: 'paymentMethods',
    displayText: 'Payment Methods',
    width: 0.3,
    align: 'left',
  },
  {
    key: 'activeModes',
    displayText: 'Active Modes',
    width: 0.6,
    align: 'left',
  },
  {
    key: 'otherAvailableModes',
    displayText: 'Other Available Modes',
    width: 0.6,
    align: 'left',
  },
  {
    key: 'requestedModes',
    displayText: 'Requested Modes',
    width: 0.4,
    align: 'left',
  },
];

export const UPI_PAYMENT_METHODS = [
  { code: 'googlepay', displayText: 'Google Pay' },
  { code: 'paytm', displayText: 'Paytm' },
  { code: 'phonepe', displayText: 'PhonePe' },
  { code: 'bhim', displayText: 'BHIM UPI' },
  { code: 'amazonpay', displayText: 'Amazon Pay' },
  { code: 'whatsapp', displayText: 'WhatsApp' },
];

export const PAYMENT_METHODS_ICON_MAPPER = {
  paypal: 'PAYPAL',
  credit: '',
  zestmoneypaylater: 'ZESTMONEY',
  zestmoney: 'ZESTMONEY',
  axis: 'AXIS',
  sc: 'STANDARD_CHARTERED',
  // epaylater: 'EPAYLATER',
  lazypay: 'LAZY_PAY',
  allahabad: '',
  andhra: '',
  boi: '',
  'icici cardless': 'ICICI',
  icici: 'ICICI',
  'Kotak Paylater': 'KOTAK',
  'kotak cardless': 'KOTAK',
  kotak: 'KOTAK',
  pnbr: '',
  sbi: 'SBI',
  yes: 'YESBANK',
  testbank: '',
  'hdfc cardless': 'HDFC',
  hdfc: 'HDFC',
  'federal cardless': 'FEDERAL',
  'homecredit cardless': 'HOME_CREDIT',
  federal: 'FEDERAL',
  sib: '',
  vijaya: '',
  deutsche: '',
  idbi: '',
  bom: '',
  cbi: '',
  indian: '',
  indusind: 'INDUSIND',
  iob: '',
  jkb: '',
  karnatka: '',
  karur: '',
  union: '',
  united: '',
  citi: 'CITI',
  corporation: '',
  paytm: 'PAYTM',
  amazonpay: 'AMAZONPAY',
  airtelmoney: 'AIRTEL_MONEY',
  phonepe: 'PHONEPE',
  ola: 'OLAMONEY',
  freecharge: 'FREECHARGE',
  'Freecharge Paylater': 'FREECHARGE',
  'Hdfc Paylater': 'HDFC_PAYLATER',
  mobikwik: 'MOBIKWIK',
  jiomoney: 'JIOMONEY',
  // oxigen: 'OXIGEN',
  testwallet: '',
  visa: 'VISA',
  mastercard: 'MASTERCARD',
  rupay: 'RUPAY',
  maestro: 'MAESTRO',
  amex: 'AMEX',
  upi: '',
  diners: 'DINERS',
  // flexmoney: 'INSTACRED',
  olapostpaid: 'OLAMONEY',
  internationalcards: 'INTERNATIONAL_CARDS',
  bob: 'BOB',
  'bob cardless': 'BOB',
  master: 'MASTERCARD',
  googlepay: 'GOOGLE_PAY',
  bhim: 'BHIM_UPI',
  kreditbee: 'KREDITBEE',
  simpl: 'SIMPL',
  'idfc cardless': 'IDFC',
  idfc: 'IDFC',
  whatsapp: 'WHATSAPP_PAYMENT_MODE',
};

export const SETTLEMENTS_ACTIVE_STATUS = 'ACTIVE';
